import React, { memo } from "react";
import GeneralSetupTab from "../../components/GeneralSetupTab";
import CenterWrapper from "../../components/CenterWrapper";
import PlansGrid from "../../components/PlansGrid";
import useCompanyUsage from "../../hooks/useCompanyUsage";

const ManageBillingPlans = () => {
  useCompanyUsage();

  return (
    <CenterWrapper>
      <div className="mb-6">
        <GeneralSetupTab
          title="Account Settings"
          subtitle="Update your company settings, team and billing."
          pageType="settings"
          activeTab="plans"
        />
        <div className="max-w-fit m-auto w-full">
          <PlansGrid
            successUrl={window.location.origin + `/settings/manage_billing`}
          />
        </div>
      </div>
    </CenterWrapper>
  );
};

export default memo(ManageBillingPlans);
